import request from '@/utils/request'

const api = {
  Preview(data) {
    return request({
      url: '/admin/form_field/preview',
      method: 'post',
      data
    })
  },
  Query(data) {
    return request({
      url: '/admin/form_field/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: '/admin/form_field/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: '/admin/form_field/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: '/admin/form_field/createOrUpdate',
      method: 'post',
      data
    })
  },
  AllCreate(data) {
    return request({
      url: '/admin/form_field/createAllList',
      method: 'post',
      data
    })
  }
}
export default api
